import { RadioGroup, FormControl } from '@mui/material';

import { IEvaluacion } from '../constants';
import FControlLabel from '../../shared/Forms/FControlLabel';
// import perdergrasaHombreS from '../../../Shared/Images/icono_grasa_hombre_2_amarillo.png';
// import musculacionHombreS from '../../../Shared/Images/icono_musculo_hombre_2_amarillo.png';
// import perdergrasaMujerS from '../../../Shared/Images/icono_grasa_mujer_2_amarillo.png';
// import musculacionMujerS from '../../../Shared/Images/icono_musculo_mujer_2_amarillo.png';
// import perdergrasaHombre from '../../../Shared/Images/icono_grasa_hombre_2.png';
// import musculacionHombre from '../../../Shared/Images/icono_musculo_hombre_2.png';
// import perdergrasaMujer from '../../../Shared/Images/icono_grasa_mujer_2.png';
// import musculacionMujer from '../../../Shared/Images/icono_musculo_mujer_2.png';


interface Props {
  dataEvaluacion: IEvaluacion;
  objetivoActual: string;
  handleChange(type: string, value: string | number): void;
  // sexo: boolean;
}

const Objetivo = ({ dataEvaluacion, objetivoActual, handleChange, /* sexo */ } : Props) => {
  return (
    <div className=''>
      <div className="text-center mb-4">
        <h2 className="title font-bold">
          ¿Deseas cambiar de objetivo para este nuevo nivel?
        </h2>
        <p className="text-slate-500">Actualmente estás en {objetivoActual === 'PG' ? '"Perder Grasa"' : '"Obtener masa muscular"'}</p>
      </div>
      <div className="row">
        <div className="col-12">
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="PG"
              name="radio-buttons-group"
              value={ dataEvaluacion.objetivo }
              onChange={(e) => {
                handleChange("objetivo", e.target.value)
              }}
              style={{ textAlign: 'left', marginBottom: '1rem' }}
            >       
              <FControlLabel value={'PG'} size='1.15rem' label={objetivoActual === 'PG' ? 'No, deseo seguir perdiendo grasa' : 'Sí, deseo perder grasa'} fontWeight={500} />
              <FControlLabel value={'MM'} size='1.15rem' label={objetivoActual === 'MM' ? 'No, deseo seguir obteniendo masa muscular' : 'Sí, deseo obtener masa muscular'} fontWeight={500} />
              
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export default Objetivo